"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventWithHeap = exports.VALIDATE_AND_SUBMIT_INPROGRESS = exports.VALIDATE_AND_SUBMIT = exports.UPDATE_FORM_FIELD = exports.REFRESH_PAGE_ERROR = exports.PF_DOC_SLATE_ERROR_EVENT = exports.PF_DOC_CHECKBOX_ERROR_EVENT = exports.INSTRUCTIONS = exports.GENERIC_ERROR = exports.FETCH_DOCUMENT = exports.CHECK_BOX_ERROR = exports.CC_INSTRUCTIONS_TITLE = exports.CC_INSTRUCTIONS = exports.BROWSER_SUPPORT_MESSAGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FETCH_DOCUMENT = 'FETCH_DOCUMENT';
exports.FETCH_DOCUMENT = FETCH_DOCUMENT;
var UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
exports.UPDATE_FORM_FIELD = UPDATE_FORM_FIELD;
var VALIDATE_AND_SUBMIT = 'VALIDATE_AND_SUBMIT';
exports.VALIDATE_AND_SUBMIT = VALIDATE_AND_SUBMIT;
var VALIDATE_AND_SUBMIT_INPROGRESS = 'VALIDATE_AND_SUBMIT_INPROGRESS';
exports.VALIDATE_AND_SUBMIT_INPROGRESS = VALIDATE_AND_SUBMIT_INPROGRESS;
var PF_DOC_SLATE_ERROR_EVENT = 'PF_DOC_SLATE_ERROR_EVENT';
exports.PF_DOC_SLATE_ERROR_EVENT = PF_DOC_SLATE_ERROR_EVENT;
var PF_DOC_CHECKBOX_ERROR_EVENT = 'PF_DOC_CHECKBOX_ERROR_EVENT';
exports.PF_DOC_CHECKBOX_ERROR_EVENT = PF_DOC_CHECKBOX_ERROR_EVENT;
var REFRESH_PAGE_ERROR = 'Document is stale. Please refresh your page';
exports.REFRESH_PAGE_ERROR = REFRESH_PAGE_ERROR;
var CHECK_BOX_ERROR = 'Please review all pages of the entire document above and check the box to agree to the terms.';
exports.CHECK_BOX_ERROR = CHECK_BOX_ERROR;
var BROWSER_SUPPORT_MESSAGE = 'If you do not have Adobe Reader installed or full PDF support in this web browser, ';
exports.BROWSER_SUPPORT_MESSAGE = BROWSER_SUPPORT_MESSAGE;
var GENERIC_ERROR = 'There was an error submitting the application. Please try again';
exports.GENERIC_ERROR = GENERIC_ERROR;
var INSTRUCTIONS = 'Please see below to accept your documents. You must review all pages of the entire document in order to proceed.';
exports.INSTRUCTIONS = INSTRUCTIONS;
var CC_INSTRUCTIONS_TITLE = 'Please review and sign your agreement.';
exports.CC_INSTRUCTIONS_TITLE = CC_INSTRUCTIONS_TITLE;
var CC_INSTRUCTIONS = 'Make sure everything looks right by reviewing all pages of the document before signing your agreement.';
exports.CC_INSTRUCTIONS = CC_INSTRUCTIONS;
var trackEventWithHeap = function trackEventWithHeap(heapCustomTrackingClient, evntNm, payload) {
  var finalPayLoad = _objectSpread({
    eventName: evntNm
  }, payload);
  if (heapCustomTrackingClient && heapCustomTrackingClient.trackCustomEvent) {
    heapCustomTrackingClient.trackCustomEvent(finalPayLoad, {});
  }
};
exports.trackEventWithHeap = trackEventWithHeap;
